import Vue from 'vue'
import App from '@/views/login'
import i18nSetting from '@/utils/languageSet'
import LangConfig from '@/locale/export/login.js'
import InitVue from '@/entries/initVue'
import '@/utils/rem.js'
import '@/style/index.scss'

const i18n = i18nSetting(LangConfig) // 多语言实例
Vue.config.productionTip = false // 关闭提示

InitVue().then(() => {
  new Vue({
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
